import mapValues from 'lodash/mapValues';
export function applyZoom(obj, zoom) {
  return mapValues(obj, val => val / zoom);
}
